import useDefinedContext from "hooks/useDefinedContext";
import { CarouselSlideIndexContext } from "../../components/CarouselSlides";

/**
 * @important
 * This hook should only be used inside a direct child of `<CarouselSlides />`.
 */
function useCarouselSlideIndex() {
  return useDefinedContext(CarouselSlideIndexContext);
}

export default useCarouselSlideIndex;
